import Vue from "vue";
import ECharts from "vue-echarts/components/ECharts";

import "echarts/lib/chart/bar";
import "echarts/lib/component/polar";
import "echarts/lib/component/tooltip";

Vue.component("v-chart", ECharts);

export default {};
